"use client";

import { CustomAvatar } from "@/features/common/components/custom-avatar";

interface PathAvatarGroupProps {
  avatars: string[];
}

export default function PathAvatarGroup({ avatars }: PathAvatarGroupProps) {
  const maxVisible = 4;
  const visibleAvatars = avatars.slice(0, maxVisible);
  const remainingCount = Math.max(avatars.length - visibleAvatars.length, 0);

  return (
    <div className="flex items-center">
      <div className="flex -space-x-2">
        {visibleAvatars.map((avatar, index) => (
          <CustomAvatar
            key={`${avatar}-${index}`}
            alt={`Avatar ${index + 1}`}
            className="ring-background ring-2"
            size="sm"
            src={avatar}
          />
        ))}
      </div>
      {remainingCount > 0 ? (
        <p className="text-small text-foreground ms-2 font-medium">
          +{remainingCount}
        </p>
      ) : null}
    </div>
  );
}
